import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Toast } from 'primereact/toast';
import { ProgressSpinner } from 'primereact/progressspinner';

import { translatedMessage } from '../../service/LanguageService';
import { UserService } from '../../service/UserService';

import EducationListComponent from '../../components/profile/EducationListComponent';
import useNavProps from '../../hooks/useNavProps';
import { useParams } from 'react-router-dom';
import ProfileToolbar from './ProfileToolbar';

const ProfileEducation = () => {
    const [user, setUser] = useState();
    const [educationList, setEducationList] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const { userIdParam } = useParams();
    const { setNavPropsValue } = useNavProps();

    const toast = useRef(null);

    const userService = useMemo(() => new UserService(), []);

    useEffect(() => {
        setIsLoading(true)

        const getProfile = async () => {
            await userService.getUserProfile(userIdParam)
                .then(async response => {
                    setUser(response)
                    setNavPropsValue('users', response.id, response.fullName)

                    await getEducation()
                })
                .catch(error => {
                    toast.current.show({ severity: 'error', summary: translatedMessage(error), life: 5000 })
                    setIsLoading(false)
                })
        }

        const getEducation = async () => {
            await userService.getUserProfileEducation(userIdParam)
                .then(educationRespone => {
                    setEducationList(educationRespone)
                    setIsLoading(false)
                })
                .catch(error => {
                    toast.current.show({ severity: 'error', summary: translatedMessage(error), life: 5000 })
                    setIsLoading(false)
                })
        }


        getProfile()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userService, userIdParam]);

    if (isLoading) {
        return (
            <div className='w-full flex align-items-center'>
                <Toast ref={toast} />
                <ProgressSpinner />
            </div>
        );
    } else {
        return (
            <>
                <Toast ref={toast} />
                <div className="grid h-full">
                    <div className="col-12">
                        <div className="card h-full">
                            <ProfileToolbar user={user} code="EDUCATION" />

                            <div className='w-full text-align-left'>
                                <h5>{translatedMessage("profile.education.title")}</h5>
                            </div>

                            <EducationListComponent
                                education={educationList}
                                onListUpdate={(list) => setEducationList(list)}
                                hasExportButton={true}
                                updateFields={false}
                                readOnly={true}
                            />
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default ProfileEducation;
